import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Factory } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Clean up any stale auth data from previous sessions
    localStorage.removeItem('token');

    try {
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password
      });

      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      toast.success('Login successful');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ 
      backgroundImage: 'url(https://images.unsplash.com/photo-1765054965145-78037f2708be?crop=entropy&cs=srgb&fm=jpg&q=85)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="flex-1 bg-black/40 backdrop-blur-sm flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="bg-white border border-border shadow-sm p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-auto mb-4 bg-white p-4">
                <img src="/mass-metalform-logo.png" alt="Mass MetalForm" className="h-16 w-auto" />
              </div>
              <p className="text-sm text-text-muted mt-2 uppercase tracking-wider">Production Management System</p>
            </div>

            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <Label htmlFor="username" className="text-xs font-semibold uppercase tracking-wider text-text-muted">Username</Label>
                <Input
                  id="username"
                  data-testid="username-input"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mt-1.5 rounded-none border-border focus:ring-1 focus:ring-accent focus:border-accent"
                  required
                  autoFocus
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-text-muted">Password</Label>
                <Input
                  id="password"
                  data-testid="password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1.5 rounded-none border-border focus:ring-1 focus:ring-accent focus:border-accent"
                  required
                />
              </div>

              <Button
                data-testid="login-button"
                type="submit"
                disabled={loading}
                className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-medium tracking-wide shadow-sm h-11"
              >
                {loading ? 'LOGGING IN...' : 'LOGIN'}
              </Button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
}